const URL = {
  CREATE_CERTIFICATE: 'certificate/{collectionId}/create',
  GET_CERTIFICATE: 'certificate/{collectionId}/get',
  PATCH_CERTIFICATE: 'certificate/{certificateId}/patch',
  GET_CERTIFICATE_LIST: 'certificate/list?collectionId={collectionId}',
}

export default URL
